import { globalHistory } from '@reach/router';
import { StaticImage } from 'gatsby-plugin-image';
import React, { Fragment, useEffect, useState } from 'react';
import Icon from '../../../basic/icons';
import QuickLink from '../../../basic/quickLink';
import { HeaderProps } from '..';
import Sidebar from './sidebar/sidebar';
import { useSidebar } from '../../../../providers/sidebar-provider';
import Image from '../../../basic/image';
import Button from '../../../basic/button';
import { useDevice } from '../../../../providers/device-provider';
import NavMenuToolbar from '../desktop/nav-menu-toolbar';
import { NotificationDialog, SearchButton } from '../desktop/headerComponents/header-steps';
import { buildAnalytics, DataAnalyticsLocations, DataAnalyticsTypes } from '../../../basic/analytics';
import { useUserProfile } from '../../../../providers/user-provider';
import { getSession } from '../../../../utils/sessionStorageUtils';

export default function MobileNavbar({ headerProps }: { headerProps: HeaderProps }): JSX.Element| null {
  const { isSideBarOpen, setIsSideBarOpen } = useSidebar();
  const { userProfile, loginError } = useUserProfile();
  if(!headerProps) return null;
  const { siteSearch, navToolbarMap, newMenuBlocks, siteLogo, regionMessages } = headerProps;
  const topToolbar = navToolbarMap?.topToolbar;
  const notificationTool = topToolbar?.notifications ||
    (topToolbar && Object.entries(topToolbar).find(([key, item]: [string, any]) =>
      key === 'notifications' || item?.icon === 'notification' || item?.icon === 'Notifications',
    )?.[1]);
  const isLoggedIn = Boolean(userProfile) || (!loginError && getSession('isLoggedIn') === 'true');
  // const { isMobile } = useDevice();
  useEffect(() => {
    if(isSideBarOpen){
      document.body.style.overflow = 'hidden'
    }else{
      document.body.style = ''
    }
    return globalHistory.listen(({ action }) => {
      if (action === 'PUSH') setIsSideBarOpen(false);
    });
  }, []);

  return (
    <Fragment>
      <header className="relative z-40 flex justify-center shadow-md bg-inky" data-testid="header-test">
        {isSideBarOpen && navToolbarMap && (
          <Sidebar menuMap={newMenuBlocks} navToolbarMap={navToolbarMap} regionMessages={regionMessages} />
        )}
        {notificationTool && isLoggedIn && (
          <NotificationDialog
            data={notificationTool}
            notificationErrorMsg={[]}
            autoOpenOnly
          />
        )}
        <nav
          className="flex items-center justify-between w-11/12 my-base"
          aria-hidden={isSideBarOpen ? 'true' : undefined}
        >

          <div className="flex items-center space-x-base ">
            {siteLogo.url && (
              <QuickLink href="/" aria-label={siteLogo.alt} data-testid="header-logo-link" dataAnalytics={buildAnalytics(DataAnalyticsLocations.Header, DataAnalyticsTypes.Media)}>
                <Image alt={siteLogo.alt} src={siteLogo.url} layout="responsive" className="w-40" />
              </QuickLink>
            )}
          </div>

          <div className='flex items-center justify-end'>
            <NavMenuToolbar toolMap={navToolbarMap} exclude={['Register']} />
            <button type="button" onClick={() => setIsSideBarOpen((prev: any) => !prev)} data-testid="menu-button">
              <Icon name={isSideBarOpen ? 'close' : 'menu'} className="text-2xl text-white ml-1" />
              <span className="font-semibold text-xs group-hover:text-secondary-300 text-white whitespace-nowrap">
                Menu
              </span>
            </button>
          </div>
        </nav>
      </header>
      <div
        className='flex items-center justify-start bg-inky py-sm px-[16px]'
        aria-hidden={isSideBarOpen ? 'true' : undefined}
      >
        <SearchButton searchBar={siteSearch}/>
      </div>
    </Fragment>
  );
}
